// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".templates-container[data-v-62ade3aa]{background-color:var(--v-background-base,#f5f5f5)}.theme--dark .templates-container[data-v-62ade3aa]{background-color:#121212!important}", ""]);
// Exports
module.exports = exports;
